import { administratorRoles } from "../../config/roles";
import { RecordDefinition } from "../recordDefinition.types";
import { seasonPageConfig } from "./seasonPageConfig";

export const seasonRecordDefinition: RecordDefinition = {
  path: "/season",
  entityName: "dwseason",
  listRoute: "/seasons",
  backTitle: "Back to seasons",
  allowedRoles: administratorRoles,
  config: seasonPageConfig,
  // The warehouse holds this record, and the view resolver never sees it.
  authorable: false,
  identity: {
    titleFields: ["name"],
    fallbackTitle: "Season",
    newRecordTitle: "New Season",
  },
};
